import OpenAI from 'openai';

/**
 * Detects if running in Electron desktop environment
 * Safe to call at module load time
 */
const _isElectron = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const win = window as Window & { electron?: any };
  return typeof win.electron !== 'undefined';
};

export const openai = new OpenAI({
  apiKey: '',
  baseURL: 'http://127.0.0.1:8000',
  timeout: 10**9, // temporarily set it as very long time to avoid timeout issue
  maxRetries: 0, // prevent secondary re-initate request to backend causing crash issue
  // Allow browser-like environment for both Electron and web versions
  // This is safe because we're using our own backend, not real OpenAI API keys
  dangerouslyAllowBrowser: true,
});